import { parseCsvText } from "./csvImportParser";
import { parseXlsxFile } from "./xlsxImportParser";

function detectFileType(file) {
  const name = String(file?.name || "").toLowerCase();
  if (name.endsWith(".csv")) return "csv";
  if (name.endsWith(".xlsx")) return "xlsx";
  return "";
}

export async function parseImportFile(file, options = {}) {
  if (!(file instanceof File)) {
    throw new Error("Geen geldig bestand geselecteerd.");
  }

  const type = detectFileType(file);
  if (!type) {
    throw new Error("Niet-ondersteund formaat. Gebruik een .csv of .xlsx bestand.");
  }

  if (type === "xlsx") {
    const parsed = await parseXlsxFile(file);
    return {
      fileType: "xlsx",
      headers: parsed.headers,
      rows: parsed.rows,
      delimiter: "",
      sheetName: parsed.sheetName,
    };
  }

  const text = await file.text();
  const parsed = parseCsvText(text, {
    delimiterPreference: options.delimiterPreference,
  });

  return {
    fileType: "csv",
    headers: parsed.headers,
    rows: parsed.rows,
    delimiter: parsed.delimiter,
    sheetName: "",
  };
}
